import { useState, useMemo } from 'react';

export interface SelectableCandidate {
  id: string;
  name: string;
  email: string;
}

export function useCandidateFilter(
  candidates: SelectableCandidate[],
  excludeIds: string[]
): {
  searchValue: string;
  setSearchValue: (value: string) => void;
  available: SelectableCandidate[];
  filtered: SelectableCandidate[];
} {
  const [searchValue, setSearchValue] = useState('');
  const available = useMemo(
    () => candidates.filter((c) => !excludeIds.includes(c.id)),
    [candidates, excludeIds]
  );
  const filtered = useMemo(() => {
    if (!searchValue) return available;
    const lower = searchValue.toLowerCase();
    return available.filter(
      (c) => c.name.toLowerCase().includes(lower) || c.email.toLowerCase().includes(lower)
    );
  }, [available, searchValue]);
  return { searchValue, setSearchValue, available, filtered };
}
